import { render } from "./ProgramSelectDialog.vue?vue&type=template&id=681f93f2&ts=true"
import script from "./ProgramSelectDialog.vue?vue&type=script&lang=ts"
export * from "./ProgramSelectDialog.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__